// Auto-import SASS generated CSS
import './index.css';

export type {CheckboxProps} from './Checkbox';
export {default as default} from './Checkbox';
